module.exports = __webpack_public_path__ + "static/tagiguana-b43d4b43c56c559159ca93375ef42406.png";